// extracted by mini-css-extract-plugin
export default {"button":"styles_button__KNAon","width":"styles_width__sLVcq","smallButton":"styles_smallButton__mafhI"};